import axios from 'axios'
import { AUTH_HEADERS, AUTH_HEADERS_FILE } from '../utils/config'
export default {
    uploadStageFile (file) {
        let formData = new FormData()
        formData.append('file', file)
        return axios.post(`${process.env.VUE_APP_BASE_URL}Import/stage`, formData, AUTH_HEADERS_FILE())
    },
    importFile (importKey) {
        return axios.post(`${process.env.VUE_APP_BASE_URL}Import/${importKey}`, importKey, AUTH_HEADERS())
    },
    getRows (keywords) {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Import?keywords=${keywords}`, AUTH_HEADERS())
    },
    getKeys (identifier) {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Import/${identifier}`, AUTH_HEADERS())
    },
    deleteInputSet (importKey){
        return axios.delete(`${process.env.VUE_APP_BASE_URL}Import/${importKey}`, AUTH_HEADERS())
    }
}
